// libs
import React, { memo } from "react";

// global Components
import styled from "@emotion/styled";
import { ICON_VARIABLES } from "styles/Icons";

const NavIcon = styled.i`
    background: transparent;
    font-size: 1.5rem;

    &:after {
        content: "${ICON_VARIABLES["icon-arrow"]}";
        color: #000;
        font-weight: 500;
    }

    &:before {
        content: "${ICON_VARIABLES["icon-arrow"]}";
        color: #fff;
        position: absolute;
        left: 2px;
    }

    &.next {
        transform: rotate(180deg);
        margin-left: -19px;
        box-shadow: 5px;
    }
`;

export const NAV_BUTTON_TYPES = {
    PREV: "prev",
    NEXT: "next",
};

// def
interface INavButtonProps {
    type: string;
}

function NavButton({ type }: INavButtonProps) {
    return <NavIcon className={`icon-arrow ${type}`} />;
}

export default memo(NavButton);
